<life-di-nav></life-di-nav>
<lifedi-breadcrumb *ngIf="workshop" [lastPath]="workshop.WORKSHOP_NAME"></lifedi-breadcrumb>

<mat-spinner *ngIf="!isLoading" class="spinner-center" style="z-index: 1000;"></mat-spinner>

<div class="container" *ngIf="workshop && isLoading">
  <div class="row justify-content-center">
    <h1 *ngIf="!workshop.REGISTED" class="lifedi-color">
      ลงทะเบียนตารางกิจกรรม
    </h1>
    <h1 *ngIf="workshop.REGISTED" class="lifedi-color">
      ตารางกิจกรรม
    </h1>

    <!-- desktop size -->
    <div class="d-none d-xxl-block d-xl-block d-lg-block d-md-block">
      <lifedi-btn *ngIf="!workshop.REGISTED && !isTimeExpires && !isFull" lable="ลงทะเบียน"
        (click)="goToScroll('target')" customStyle="position: absolute; right: 10%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:
      #FFFFFF">
      </lifedi-btn>
      <lifedi-btn *ngIf="workshop.REGISTED" lable="ลงทะเบียนแล้ว" disabled="true"
        customStyle="position: absolute; right: 10%; margin-top: 0px; padding: 0 25px;">
      </lifedi-btn>
      <lifedi-btn *ngIf="!workshop.REGISTED && isTimeExpires" lable="หมดเวลาลงทะเบียน" disabled="true"
        customStyle="position: absolute; right: 8%; margin-top: 0px; padding: 0 25px;">
      </lifedi-btn>
      <lifedi-btn *ngIf="!workshop.REGISTED && !isTimeExpires && isFull" lable="เต็ม" disabled="true"
        customStyle="position: absolute; right: 8%; margin-top: 0px; padding: 0 25px;">
      </lifedi-btn>
    </div>
  </div>

  <!-- mobile size -->
  <div class="row mt-1 d-none d-block d-sm-none d-sm-block d-md-none" style="text-align: right;">
    <lifedi-btn *ngIf="!workshop.REGISTED && !isTimeExpires && !isFull" class="col" lable="ลงทะเบียน"
      (click)="goToScroll('target')" customStyle="margin-top: 0px; padding: 0 25px; background: #005C3D; color:
    #FFFFFF">
    </lifedi-btn>
    <lifedi-btn *ngIf="workshop.REGISTED" class="col" lable="ลงทะเบียนแล้ว" disabled="true"
      customStyle="margin-top: 0px; padding: 0 25px;">
    </lifedi-btn>
    <lifedi-btn *ngIf="!workshop.REGISTED && isTimeExpires" class="col" lable="หมดเวลาลงทะเบียน" disabled="true"
      customStyle="margin-top: 0px; padding: 0 25px;">
    </lifedi-btn>
    <lifedi-btn *ngIf="!workshop.REGISTED && !isTimeExpires && isFull" class="col" lable="เต็ม" disabled="true"
      customStyle="margin-top: 0px; padding: 0 25px;">
    </lifedi-btn>
  </div>

  <div class="row mt-4">
    <div class="col-md-6 col-12">
      <img width="100%" [src]="workshop.WORKSHOP_PIC">
    </div>
    <div class="col-md-6 col-12">
      <div class="row">
        <h3
          class="lifedi-color underline col-12 d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
          ชื่อ Workshop</h3>
        <h3 class="lifedi-color col-12 mt-4 d-none d-block d-sm-none d-sm-block d-md-none underline">ชื่อ Workshop</h3>
        <p class="col-12" style="font-size: large;">{{ workshop.WORKSHOP_NAME }}</p>
      </div>

      <div class="row">
        <h3
          class="lifedi-color underline col-12 d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
          ราคา</h3>
        <h3 class="lifedi-color col-12 mt-4 d-none d-block d-sm-none d-sm-block d-md-none underline">ราคา</h3>
        <p *ngIf="workshop.WORKSHOP_PRICE === 0" class="col-12" style="font-size: large;">ฟรี</p>
        <p *ngIf="workshop.WORKSHOP_PRICE > 0" class="col-12" style="font-size: large;">
          {{ workshop.WORKSHOP_PRICE | number }} บาท
        </p>
      </div>

      <div class="row">
        <div *ngIf="workshop.JOIN_TYPE === 'On-site'">
          <h3 class="lifedi-color underline col-12 mt-3">สถานที่จัดงาน</h3>
          <div class="col-12">
            <p style="font-size: large;">
              {{ workshop.WORKSHOP_PLACE }}
            </p>
          </div>
        </div>
        <div *ngIf="workshop.JOIN_TYPE === 'Online'">
          <h3 class="lifedi-color underline col-12 mt-3">สถานที่จัดงาน</h3>
          <div class="col-12">
            <p style="font-size: large;">
              {{ workshop.JOIN_TYPE }}
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <h3 class="lifedi-color underline col-12 mt-3">วัน เวลา</h3>
        <div *ngFor="let date of workshop.WORKSHOP_DATE" class="col-12">
          <p style="font-size: large;">
            {{ date['dateTime'][0] | dateTime:'shortNoTime' }} &nbsp;
            {{ date['dateTime'][0] | dateTime:'time' }}
            <span *ngIf="!date['dateTime'][1]">น.</span>
            <span *ngIf="date['dateTime'][1]"> - {{ date['dateTime'][1] | dateTime: 'time' }} น.</span>
          </p>
        </div>
      </div>
      <div class="row">
        <h3 class="lifedi-color underline col-12 mt-3">วิทยากร</h3>
        <p class="col-12" style="font-size: large;">{{ workshop.WORKSHOP_COACH }}</p>
      </div>
      <div *ngIf="workshop.WORKSHOP_COACH_ASSIT.length === 0">
      </div>
      <div class="row" *ngIf="workshop.WORKSHOP_COACH_ASSIT.length !== 0">
        <h3 class="lifedi-color underline col-12 mt-3">วิทยากรร่วม</h3>
        <p class="col-12" style="font-size: large;"
          *ngFor="let assistCoach of workshop.WORKSHOP_COACH_ASSIT; let i = index">
          {{ workshop.WORKSHOP_COACH_ASSIT[i] }}</p>
      </div>
    </div>
  </div>
  <div class="row mt-4">
    <h3 class="lifedi-color underline col-12">รายละเอียด</h3>
    <div id="_content" class="col-12 mb-2" [ngClass]="!workshop.REGISTED && !isTimeExpires && !isFull ? '' : 'mb-5'"
      [innerHtml]="workshopDetail"></div>
  </div>

  <hr *ngIf="!workshop.REGISTED && !isTimeExpires && !isFull" class="mt-4 mb-4" width="60%" align="center"
    style="border-top: 2px solid rgba(0,0,0,.1);">

  <div *ngIf="!workshop.REGISTED && !isTimeExpires && !isFull && !workshop.HAVE_LOGIN"
    class="row justify-content-center text-center mt-5">
    <h3 id="target" class="lifedi-color col-12">เข้าสู่ระบบ เพื่อลงทะเบียน</h3>
    <div class="form-group row mt-3 mb-4">
      <lifedi-btn lable="เข้าสู่ระบบ" customStyle="color:white; background-color: #414A6B; width: 100%; padding: 0 50px"
        (click)="openLogin()"></lifedi-btn>
    </div>
  </div>

  <div *ngIf="!workshop.REGISTED && !isTimeExpires && !isFull && workshop.HAVE_LOGIN" class="row">
    <h3 id="target" class="lifedi-color underline col-12">ลงทะเบียน</h3>
    <div class="form-group container">
      <form [formGroup]="workshopRegisterForm">
        <div class="row">
          <label for="name" class="col-md-2 col-form-label my-2">ชื่อ<lifedi-require></lifedi-require></label>
          <div class="col-md-4">
            <input type="text" class="form-control my-2" id="name" formControlName="name" autocomplete="off">
          </div>
          <label for="lastname" class="col-md-2 col-form-label my-2">นามสกุล<lifedi-require></lifedi-require></label>
          <div class="col-md-4">
            <input type="text" class="form-control my-2" id="lastname" formControlName="lastname" autocomplete="off">
          </div>
        </div>
        <div class="row">
          <label for="type" class="col-md-2 col-form-label my-2">สถานะผู้สมัคร<lifedi-require></lifedi-require></label>
          <div class="col-md-4">
            <select class="custom-select form-control my-2" id="type" formControlName="type">
              <option value="" selected disabled hidden>เลือกสถานะ</option>
              <option *ngFor="let t of registerType" [id]="t.TYPE_ID" [value]="t.TYPE_NAME">{{t.TYPE_NAME}}</option>
            </select>
          </div>
          <label for="affiliate" class="col-md-2 col-form-label my-2">สังกัด
            <span class="text-danger">(ถ้ามี)</span>
          </label>
          <div class="col-md-4">
            <input type="text" class="form-control my-2" id="affiliate" formControlName="affiliate" autocomplete="off">
          </div>
        </div>
      </form>
      <div class="row justify-content-center mt-4">
        <div class="text-danger">{{errorMassage}}</div>

        <div *ngIf="role === 'teacher' || role === 'admin' || role === 'psychologist'">
          <lifedi-btn *ngIf="!workshopRegisterForm.valid" lable="ลงทะเบียน" customStyle="padding: 0 50px"
            [disabled]="!workshopRegisterForm.valid">
          </lifedi-btn>
          <lifedi-btn *ngIf="workshopRegisterForm.valid" lable="ลงทะเบียน"
            customStyle="color:white; background-color: #3E8C1A; padding: 0 50px" (click)="cannotRegist()">
          </lifedi-btn>
        </div>
        <div *ngIf="role === 'user'">
          <lifedi-btn *ngIf="workshopRegisterForm.valid" lable="ลงทะเบียน"
            customStyle="color:white; background-color: #3E8C1A; padding: 0 50px"
            (click)="register(workshopRegisterForm.value)">
          </lifedi-btn>
          <lifedi-btn *ngIf="!workshopRegisterForm.valid" lable="ลงทะเบียน" customStyle="padding: 0 50px"
            [disabled]="!workshopRegisterForm.valid">
          </lifedi-btn>
        </div>
      </div>
    </div>
  </div>
</div>

<lifedi-footer *ngIf="workshop && isLoading"></lifedi-footer>
